import ConfirmFormFooter from "../../Components/antd/Forms/ConfirmFormFooter"

export const WithFormFooter = ({ visible, ...props }) => {
  const { children } = props

  return (
    <>
      {visible && (
        <div className='pd-12 mt-4'>
          {children}

          <div className='pdb-8 pdl-12 pdr-12'>
            <ConfirmFormFooter {...props} />
          </div>
        </div>
      )}
    </>
  )
}

export default WithFormFooter